module.exports = __webpack_public_path__ + "static/img/9.ec0bc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/9.png
// module id = JfhB
// module chunks = 0